//**************************************************************************************************
//  サイドナビ
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { Component, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';

import { TranslatePipe } from "@ngx-translate/core";

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';

import { AppConst } from '../../app-const';

import { SessionService } from '../services/session-service';
import { Session }  from '../../class/session';

import { FireSysAdmin } from '../models/fire/sys_admin';
import { FireLeAdmin } from '../models/fire/le_admin';
import { FireLeUser } from '../models/fire/le_user';
import { FireEventInfo } from '../models/fire/event_info';
import { FireEventShow } from '../models/fire/event_show';
import { FireReserveInfo } from '../models/fire/reserve_info';

//==================================================================================================
//  Component
//==================================================================================================
@Component({
  selector: 'app-sidenav',
  imports: [
    CommonModule,
    TranslatePipe,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatToolbarModule,
  ],
  templateUrl: './sidenav.html',
  styleUrl: './sidenav.css'
})
//==================================================================================================
//
//==================================================================================================
export class Sidenav {
  //================================================================================================
  //  @ViewChild  （HTML内の要素との紐付けを宣言）
  //================================================================================================
  @Output() sidenavClose        = new EventEmitter();
  @Output() sidenavToggle       = new EventEmitter();
  //================================================================================================
  //  変数定義
  //================================================================================================
  isLogin                       : boolean                 = false;
  isAuthSA                      : boolean                 = false;                                  //  システム管理者
  isAuthLA                      : boolean                 = false;                                  //  LE管理者
  isAuthLU                      : boolean                 = false;                                  //  LEユーザー
  isEventInfo                   : boolean                 = false;                                  //  興行
  isEventShow                   : boolean                 = false;                                  //  開催
  isReserveInfo                 : boolean                 = false;                                  //  予約
  //------------------------------------------------------------------------------------------------
  sessionUid                    : string | null           = null;                                   //  セッション情報：UID
  sessionSysAdmin               : FireSysAdmin | null     = null;                                   //  セッション情報：システム管理者
  sessionLeAdmin                : FireLeAdmin | null      = null;                                   //  セッション情報：LE管理者
  sessionLeUser                 : FireLeUser | null       = null;                                   //  セッション情報：LEユーザー
  sessionEventInfo              : FireEventInfo | null    = null;                                   //  セッション情報：興行
  sessionEventShow              : FireEventShow | null    = null;                                   //  セッション情報：開催
  sessionReserveInfo            : FireReserveInfo | null  = null;                                   //  セッション情報：予約
  //================================================================================================
  //  コンストラクタ
  //================================================================================================
  constructor(
    private sessionService: SessionService) { }
  //================================================================================================
  //  初期処理
  //================================================================================================
  ngOnInit(): void {
    this.sessionService.sessionState.subscribe((session: Session)=> {
      if (session) {
        this.isLogin            = session.isLogin;
        this.sessionUid         = session.uid;
        this.sessionSysAdmin    = session.sysAdmin;
        this.sessionLeAdmin     = session.leAdmin;
        this.sessionLeUser      = session.leUser;
        this.sessionEventInfo   = session.eventInfo;
        this.sessionEventShow   = session.eventShow;
        this.sessionReserveInfo = session.reserveInfo;
        //------------------------------------------------------------------------------------------
        this.isAuthSA           = !!this.sessionSysAdmin ?  true : false;
        this.isAuthLA           = !!this.sessionLeAdmin ?   true : false;
        this.isAuthLU           = !!this.sessionLeUser ?    true : false;
        this.isEventInfo        = !!this.sessionEventInfo ?  true : false;
        this.isEventShow        = !!this.sessionEventShow ?  true : false;
        this.isReserveInfo      = !!this.sessionReserveInfo ?  true : false;
        //------------------------------------------------------------------------------------------
      }
    })
  }
  //================================================================================================
  //  終了処理
  //================================================================================================
  ngOnDestroy(): void {
  }
}
